import script from "./confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm.vue?vue&type=script&setup=true&lang=js"

import "./confirm.vue?vue&type=style&index=0&id=572fec62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-572fec62"]])

export default __exports__